module.exports = __webpack_public_path__ + "static/media/logo.f1924fba.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.png
// module id = 979
// module chunks = 0